export const localurl = 'http://localhost:5010';
export const liveurl = 'https://wms.bfccapital.com';